<template>
  <div class="row">
    <div class="col-md-12">
      <h4 class="title">User Fields</h4>
    </div>
    <div class="col-md-12 card">
      <div class="card-header">
        <p-button class="btn btn-primary pull-right" @click="createUserFields">
        <i class="fa fa-plus"></i>  New User Fields
      </p-button>
        <!-- <div class="category">Forms</div> -->
      </div>
      <div class="card-body row">
        <div class="col-sm-6">
          <el-select v-model="pagination.perPage" placeholder="Per page">
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <div class="col-sm-6">
          <div class="pull-right">
            <fg-input
              class="input-sm"
              placeholder="Search"
              v-model="searchQuery"
              addon-right-icon="nc-icon nc-zoom-split"
            ></fg-input>
          </div>
        </div>
        <div class="col-sm-12 mt-2">
          <el-table v-loading="loading"
            element-loading-text="Loading data..." class="table-striped" :data="queriedData" border style="width: 100%">
            <el-table-column
              v-for="column in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
            ></el-table-column>
            <el-table-column :min-width="120" fixed="right" class-name="td-actions" label="Actions">
              <template slot-scope="props">
                <p-button type="primary" size="sm" icon @click="handleEdit(props.$index, props.row)">
                  <i class="fa fa-edit"></i>
                </p-button>
                <p-button
                  type="danger"
                  size="sm"
                  icon
                  @click="handleDelete(props.$index, props.row)"
                >
                  <i class="fa fa-trash"></i>
                </p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-primary">
          <p class="category">Showing {{ from + 1 }} to {{ to }} of {{ total }} entries</p>
        </div>
        <div class="col-sm-6">
          <p-pagination
            class="pull-right"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
          ></p-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
import Sidebar from "src/sidebarLinks.js";

import { Message, Form } from "element-ui";

import Resource from "@/util/Api/resource.js";
const FormResource = new Resource("forms");

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
export default {
  components: {
    PPagination
  },
  computed: {
    pagedData() {
      return this.tableData.slice(this.from, this.to);
    },
    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedData() {
      if (!this.searchQuery) {
        this.pagination.total = this.tableData.length;
        return this.pagedData;
      }
      let result = this.tableData.filter(row => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString();
          rowValue = rowValue.toLowerCase();
          this.searchQuery = this.searchQuery.toLowerCase();
          if (rowValue.includes && rowValue.includes(this.searchQuery)) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      this.pagination.total = this.tableData.length;
      return this.tableData.length;
    }
  },
  data() {
    return {
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [50, 100, 200, 500],
        total: 0
      },
      searchQuery: "",

      propsToSearch: ["name"],

      tableColumns: [
        {
          prop: "name",
          label: "Name",
          minWidth: 300
        }
      ],

      tableData: [],
      loading: false,
    };
  },
  created() {
    this.getForms();
  },
  methods: {
    showAlertMessage(message, type) {
      this.$message.closeAll();
      this.$message({
        type: type,
        message: message
      });
    },
    handleDelete(index, row) {
      this.$confirm("Are you sure you want to delete this form?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        cancelButtonClass: "btn-danger",
        confirmButtonClass: "btn-primary",
        type: "warning"
      })
        .then(() => {
          let indexToDelete = this.tableData.findIndex(
            tableRow => tableRow.id === row.id
          );
          if (indexToDelete >= 0) {
            this.form = row;
            FormResource.destroy(this.form.id)
              .then(response => {
                this.tableData.splice(indexToDelete, 1);
                this.showAlertMessage(response.message, "success");
              })
              .catch(error => {});
          }
        })
        .catch(() => {});
    },
    handleEdit(index, row) {
      this.$router.push({
        name: "EditForm",
        params: { id: row.id }
      });
    },
    async getForms() {
      this.loading = true;
      await FormResource.list({})
        .then(response => {
          this.tableData = response.data;
          this.loading = false;
        })
        .catch(error => {
          console.log("error occured");
        });
    },

    createUserFields() {
      this.$router.push({ name: "CreateUserFields" });
    }
  }
};
</script>
<style lang="scss">
.el-table .td-actions {
  button.btn {
    margin-right: 5px;
  }
}
a.custom-link {
  background-color: #2c2c2c;
  padding: 20px;
  color: white;
  text-transform: uppercase;
  font-weight: 700;
}
a.custom-link:hover {
  background-color: #6bd098;
  color: white;
}
</style>
